module.exports = __webpack_public_path__ + "img/国家专精特新企业.661b9da0.svg";